import React from "react";
import { Link } from "react-router-dom";

export default function EntityShareCard({ sharedEntity }) {
  if (!sharedEntity) {
    return null;
  }

  const isProperty = sharedEntity.type === "property";
  const typeLabel = isProperty ? "Об'єкт" : "Клієнт";
  const iconClass = isProperty ? "fa-solid fa-house" : "fa-regular fa-user";

  if (!sharedEntity.available) {
    return (
      <div className="chat-entity-card chat-entity-card--unavailable" aria-label={typeLabel}>
        <span className="chat-entity-card__icon" aria-hidden="true">
          <i className={iconClass} />
        </span>
        <span className="chat-entity-card__body">
          <span className="chat-entity-card__type">{typeLabel}</span>
          <span className="chat-entity-card__title">Недоступно</span>
        </span>
      </div>
    );
  }

  const to = sharedEntity.url
    || (isProperty ? `/realty/${sharedEntity.id}` : `/clients/${sharedEntity.id}`);

  return (
    <div className="chat-entity-card">
      <span className="chat-entity-card__icon" aria-hidden="true">
        <i className={iconClass} />
      </span>
      <span className="chat-entity-card__body">
        <span className="chat-entity-card__type">{typeLabel}</span>
        <Link
          to={to}
          className="chat-entity-card__link"
          title={sharedEntity.label}
        >
          <span className="chat-entity-card__title">{sharedEntity.label}</span>
        </Link>
      </span>
    </div>
  );
}
